import { useMemo, useState } from "react";
import { useApiUrl, useCustom, useTranslate } from "@refinedev/core";
import { NumberField } from "@refinedev/antd";
import { Line } from "@ant-design/charts";
import { LineConfig } from "@ant-design/plots/lib/components/line";
import dayjs, { Dayjs } from "dayjs";
import { Row, Col, Card, Typography, Form, Select, } from "antd";
import { useConfigProvider } from 'context';
import { IncreaseIcon, DecreaseIcon } from "components/icons";

import { ISalesChart } from "interfaces";




export const LineChart: React.FC<any> = ({ type, start, end, gameTypeId, channelId }) => {
    const t = useTranslate();
    const API_URL = useApiUrl();
    const timeTransfer = (obj:any) => {
        if(obj){
            const year = obj.$y;
            const month = obj.$M;  // 注意，月份在Date对象里是从0开始的
            const date = obj.$D;
            const hours = obj.$H;
            const minutes = obj.$m;
            const seconds = obj.$s;
            const milliseconds = obj.$ms;
            const dateObject = new Date(year, month, date, hours, minutes, seconds, milliseconds);
            return dateObject.getTime();
        }
    }
    const { mode } = useConfigProvider();
    let query = {}
    let url = ''
    if (type === 'Multi') {
        query = {
            start: timeTransfer(start.start1),
            end: timeTransfer(end.end1),
            gameId: gameTypeId.multiGameTypeId ,
            channelId: channelId.multiChannelId
        };
        // url = `${API_URL}/roomtiming/getData`;
        
        // url = `http://192.168.31.248:7001/api/new/roomtiming/getData`;

        // url = `https://api.finefoods.refine.dev/dailyRevenue`;
        // url = `http://jifei.zoomsh.cn/api/new/roomtiming/getCcu`;
        url = `https://admin.lockdown.zoomsh.cn/api/api/new/roomtiming/getCcu`;

    }
    if (type === 'Duration' || type === 'Times') {
        query = {
            startTime: timeTransfer(start.start2),
            endTime: timeTransfer(end.end2),
            gameId: gameTypeId.gameTypeId,
            channelId: channelId.channelId
        };
        // url = `https://api.finefoods.refine.dev/dailyRevenue`;
        // url = `http://jifei.zoomsh.cn/api/new/roomtiming/getData`;
        url = `https://admin.lockdown.zoomsh.cn/api/api/new/roomtiming/getData`;

    }

    const { data, isLoading } = useCustom<{
        data: any;
      
    }>({
        url,
        method: "get",
        config: {
            query
        },
    });
    let dataTrans: { date: string; value: number }[] | undefined;


    if(type === 'Duration'){
        if(data?.data?.data?.data){
            dataTrans = []
            for(const i in data.data.data.data){
                const { duration } = data.data.data.data[i];
                dataTrans.push({
                    date: i,
                    value: Math.floor(duration / 1000 / 60)
                })
            }
        }
    }else if( type === 'Times'){
        if(data?.data?.data?.data){
            dataTrans = []
            for(const i in data.data.data.data){
                const { startupTime } = data.data.data.data[i];
                dataTrans.push({
                    date: i,
                    value: startupTime
                })
            }
        }
    }
  
    const config = useMemo(() => {
        const config: LineConfig = {
            data: type === 'Multi' ? data?.data.data.ccu || [] : dataTrans || [],
            loading: isLoading,
            padding: "auto",
            xField: "date",
            yField: "value",
            color: "rgba(255, 255, 255, 1)",
            tooltip: {
                customContent: (title, data) => {
                    return `<div style="padding: 8px 4px; font-size:16px; font-weight:600">${data[0]?.value} ${type === 'Multi' ? '人' : type === 'Duration' ? '分钟' : type === 'Times' ? '次' : ''} </div>`;
                },
            },
            xAxis: {
                label: {
                    style: {
                        fill: mode === 'light' ? '#ffffff' : '#8c8c8c' ,  // 字体颜色
                    }
                },
                line: {
                    style: {
                        stroke: mode === 'light' ? '#ffffff' : '#ccc',  // 轴线颜色
                    }
                },
            },
            yAxis: {
                label: {
                    style: {
                        fill: mode === 'light' ? '#ffffff' : '#8c8c8c',  // 字体颜色
                    }
                },
                grid: null,
                line: {
                    style: {
                        stroke: mode === 'light' ? '#ffffff' : '#ccc',  // 轴线颜色
                    }
                },
            },
            smooth: true,
            lineStyle: {
                lineWidth: 4,
            },
        };
        return config;
    }, [data]);

    const disabledDate = (date: Dayjs) => date > dayjs();

    return (
        <Line
            padding={0}
            appendPadding={10}
            height={200}
            style={{ maxHeight: "235px" }}
            {...config}
        />

    );
};
